<template>
  <div>
    <h1>Cliente</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn to="/customers" text><v-icon>view_list</v-icon></v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-menu v-if="this.id" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text> <v-icon>list_alt</v-icon>Opções </v-btn>
            </template>
            <v-list>
              <v-list-item :to="`/contract/for-customer/${this.id}`">
                <v-list-item-title>Novo Contrato</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            text
            v-if="this.id"
            @click="confirmDeleteCustomer"
            color="error"
            >Excluir</v-btn
          >
          <v-btn text @click="saveCustomer">Salvar</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-tabs
            centered
            background-color="primary"
            dark
            slider-color="primary"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab ripple>Dados do Cliente</v-tab>
            <v-tab ripple>Informações Adicionais</v-tab>
            <v-tab ripple>Marketing</v-tab>
            <v-tab :disabled="!this.id || this.id <= 0" ripple>Contratos</v-tab>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <PersonalData :customer="customer" />
                </v-flex>
                <v-flex md12 mt-3>
                  <ContactData :customer="customer" />
                </v-flex>
                <v-flex md12 mt-3>
                  <AddressCard :address="customer.address" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <AdditionalInfo :customer="customer" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <MarketingData :customer="customer" />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <Contracts :customer="customer" />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
    <OperationStatusCard
      id="loadingStatusCard"
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      id="operationStatusCard"
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
    <ConfirmDialog
      id="confirmDeleteDialog"
      ref="confirmDeleteDialog"
      title="Excluir Registro"
      :message="`Deseja realmente excluir o cliente ${this.customer.name}?`"
      yes-button="Sim"
      no-button="Não"
      @confirm="deleteCustomer"
    />
  </div>
</template>
<script>
import api from "@/api";
import AddressCard from "@/components/Shared/AddressCard";
import ContactData from "@/components/Customer/ContactData";
import PersonalData from "@/components/Customer/PersonalData";
import MarketingData from "@/components/Customer/MarketingData";
import AdditionalInfo from "@/components/Customer/AdditionalInfo";
import Contracts from "@/components/Customer/Contracts";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "customer-form",
  components: {
    AddressCard,
    ContactData,
    PersonalData,
    MarketingData,
    AdditionalInfo,
    Contracts,
    ConfirmDialog,
    OperationStatusCard
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  data() {
    return {
      customer: {
        address: {}
      }
    };
  },
  methods: {
    saveCustomer() {
      this.$refs.operationStatusCard.show();
      var endpoint = this.id ? `/customers/${this.id}` : "/customers";
      var method = this.id ? "PUT" : "POST";
      api
        .request(method, endpoint, this.customer)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.$router.push("/customers");
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    },
    confirmDeleteCustomer() {
      this.$refs.confirmDeleteDialog.show();
    },
    deleteCustomer() {
      this.$refs.operationStatusCard.show();
      api
        .request("DELETE", `/customers/${this.id}`, this.customer)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.$router.push("/customers");
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/customers/${this.id}`)
        .then(response => {
          this.customer = response.data;
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    }
  }
};
</script>
